import React, { useEffect, useState } from 'react'
import { motion } from "motion/react"
import { FaSun, FaMoon, FaAdjust } from "react-icons/fa"

// Three states: "system" (follow the OS setting, and keep following it live),
// or an explicit "light"/"dark" override that sticks until the user cycles
// back around to "system".
const NEXT = { system: "light", light: "dark", dark: "system" };
const ICONS = { system: FaAdjust, light: FaSun, dark: FaMoon };
const LABELS = { system: "system", light: "light", dark: "dark" };

const getStored = () => {
  const stored = localStorage.getItem("theme");
  return stored === "light" || stored === "dark" ? stored : "system";
};

const systemPrefersDark = () => window.matchMedia("(prefers-color-scheme: dark)").matches;

const ThemeToggle = () => {
  const [mode, setMode] = useState(getStored);

  // While in "system" mode, keep following live OS changes.
  useEffect(() => {
    if (mode !== "system") return;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => document.documentElement.classList.toggle("dark", media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, [mode]);

  useEffect(() => {
    const dark = mode === "dark" || (mode === "system" && systemPrefersDark());
    document.documentElement.classList.toggle("dark", dark);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", dark ? "#0a0e14" : "#fafafa");
    if (mode === "system") localStorage.removeItem("theme");
    else localStorage.setItem("theme", mode);
  }, [mode]);

  const cycle = () => setMode((m) => NEXT[m]);
  const Icon = ICONS[mode];

  return (
    <motion.button
      onClick={cycle}
      whileTap={{ scale: 0.9 }}
      aria-label={`Theme: ${LABELS[mode]} (click to change)`}
      title={`Theme: ${LABELS[mode]}`}
      className="inline-flex h-5 w-5 items-center justify-center text-mist-400 transition-colors hover:text-mist-100"
    >
      <Icon size={16} />
    </motion.button>
  )
}

export default ThemeToggle
